import { Download, Trash2, Eye } from "lucide-react";
import { AuthImage } from "./AuthImage";
import { fmtDate, fmtSize } from "./format";

export const PhotoCard = ({ photo, onView, onDownload, onDelete, canDeletePhotos }) => (
  <div data-testid="photo-card" className="border border-[#33424f]/20 bg-white flex flex-col">
    <button
      type="button"
      onClick={() => onView(photo)}
      data-testid="photo-thumb"
      className="relative block w-full aspect-[4/3] overflow-hidden group"
      aria-label={`View ${photo.original_file_name}`}
    >
      <AuthImage
        src={`/photos/${photo.id}/thumbnail`}
        alt={photo.original_file_name}
        className="w-full h-full object-cover"
      />
      <span className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
        <Eye className="w-7 h-7 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
      </span>
    </button>

    <div className="p-3 flex-1 flex flex-col">
      <div className="font-body text-sm font-medium text-[#33424f] truncate" title={photo.original_file_name}>
        {photo.original_file_name}
      </div>
      <div className="text-[11px] text-[#50493b] mt-0.5">
        {fmtDate(photo.uploaded_at)}
        {photo.file_size ? ` · ${fmtSize(photo.file_size)}` : ""}
      </div>
      {photo.uploaded_by_name && (
        <div className="text-[11px] text-[#7a6f57]">by {photo.uploaded_by_name}</div>
      )}

      <div className="mt-3 pt-3 border-t border-[#33424f]/15 flex items-center gap-2">
        <button
          type="button"
          onClick={() => onView(photo)}
          data-testid="photo-view-btn"
          className="h-11 w-11 inline-flex items-center justify-center border border-[#33424f]/20 text-[#39678f] hover:bg-[#eef3f8]"
          aria-label="View photo"
          title="View"
        >
          <Eye className="w-5 h-5" />
        </button>
        <button
          type="button"
          onClick={() => onDownload(photo)}
          data-testid="photo-download-btn"
          className="h-11 w-11 inline-flex items-center justify-center border border-[#33424f]/20 text-[#33424f] hover:bg-[#f0ece3]"
          aria-label="Download photo"
          title="Download"
        >
          <Download className="w-5 h-5" />
        </button>
        {canDeletePhotos && (
          <button
            type="button"
            onClick={() => onDelete(photo)}
            data-testid="photo-delete-btn"
            className="h-11 w-11 inline-flex items-center justify-center border border-[#b30035]/30 text-[#b30035] hover:bg-[#fbe4ea] ml-auto"
            aria-label="Delete photo"
            title="Delete"
          >
            <Trash2 className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  </div>
);
